import React, {  useState } from 'react';

import { OptionProps, SelectProps } from 'antd/es/select';
import Select from 'antd/lib/select';

import Text from '@components/Text';
import { FontFamilyVariant, TextType } from '@components/Text';

import defaultAreas from './countries.json'
import { Area } from './CountryTypes';

export interface AreaSelectProps extends SelectProps<any> {
    optionProps?: OptionProps;
    filterArea?: (value: Area, index: number, array: Area[]) => boolean;
    areaProcessor?: (value: Area) => Area;
    emptyResult?: string;
}

export const CountryCodeSelect = ({
                               optionProps,
                               filterArea,
                               areaProcessor,
                               emptyResult,
                               ...selectProps
                           }: AreaSelectProps) => {


    return (
        <span
            onMouseUp={(e) => {
                e.stopPropagation();
            }}
        >
      <Select
          showArrow
          bordered={false}
          dropdownMatchSelectWidth={false}
          optionLabelProp="label"
          filterOption={(input, option) => {
              const key = option?.key;
              return (
                  (key as string).toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
          }}
          notFoundContent={<Text className={`validation-error`} textType={TextType.paragraph1} fontFamilyVariant={FontFamilyVariant.light} text={emptyResult} />}
          {...selectProps}
          disabled
      >
        {defaultAreas
            .filter((value: Area, index: number, array: Area[]) => {
                return filterArea ? filterArea(value, index, array) : true;
            })
            .map((_item) => {
                const item = areaProcessor?.(_item) || _item;
                const key = `${item.name} ${item.phoneCode}`;
                const fixedProps = {
                    key,
                    value: item.short,
                    label: (
                        <>
                            {item.emoji} +{item.phoneCode}
                        </>
                    ),
                };
                return (
                    <Select.Option {...optionProps} {...fixedProps}>
                        {item.emoji} {key}
                    </Select.Option>
                );
            })}
      </Select>
    </span>
    );
};

export default CountryCodeSelect;
